import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './UnderlyingPolicies.metadata.json5';
import { formatCurrency, Chevron } from '@jutro/components';
import { Link } from 'gw-components-platform-react';
import styles from '../../Summary.module.scss';
import { TranslatorContext } from '@jutro/locale';
import messages from './UnderlyingPolicies.messages';

function UnderlyingPolicies(props) {
    const { intl, data} = props;
    const translator = useContext(TranslatorContext);

    let underlyingPolicyData = data.map((policy, index) => {
        return {
            policyType: translator({id: 'typekey.RelatedPolicyType_EY.' + policy.policyType}),
            policyNumber: policy.policyNumber,
            effectiveDate: intl.formatDate(new Date(policy.effectiveDate), { year: 'numeric', month: 'short', day: 'numeric' }),
            expirationDate: intl.formatDate(new Date(policy.expirationDate), { year: 'numeric', month: 'short', day: 'numeric' }),
            liabilityLimit: formatCurrency(intl, { value: policy.liabilityLimit.amount, currency: 'cad', showFractions: true, currencyDisplay: 'symbol' })
        };
    })

    const getPolicyNumberLink = (items, index, property) => {
        const redirectRoute = {
            pathname: `/policies/${items[property.id]}/summary`
        };
        return (
            <Link to = {redirectRoute} > 
                {items[property.id]}
            </Link>
        );
    };

    const getCell = (items, index, property) => {
        return !_.isObject(items[property.id]) ? items[property.id] : null;
    };    

    const getHeaderInfo = useCallback(() => {
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
                <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>
                    {translator(messages.underlyingPolicies)}
                </h2>
            </React.Fragment>
        );
    }, [translator]);

    const overrides = {
        umbrellaUnderlyingPolicyTable: {
            data: underlyingPolicyData
        },
        umbrellaUnderlyingPolicyCard: {
            header: getHeaderInfo()
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            getCellValue: getCell,
            getLink: getPolicyNumberLink
        },
        resolveClassNameMap: styles
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={underlyingPolicyData}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

UnderlyingPolicies.defaultProps = {
    data: [],
};
export default UnderlyingPolicies;
